import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { explodeArray } from "../../../../config/global";
import { setShowPaymentPlans } from "../../../../redux/Slices/Global/globalSlice";
import { useDispatch } from "react-redux";
import { isUiOnlyFeatureKey } from "../../../../utils/featureKeys";

function FeaturesList({ selectedPackage, actionBtn = false }) {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const dispatch = useDispatch()
  if (!selectedPackage?.features) return null;

  // UI-only keys are excluded before slicing/counting so the card is unchanged by their presence.
  const entries = Object.entries(selectedPackage.features).filter(([key]) => !isUiOnlyFeatureKey(key));
  const visibleEntries = showAll ? entries : entries.slice(0, 4);

  return (
    <div className="">
      {visibleEntries.map(([key, value], index) =>
        value ? (
          <div
            className="mb-1 fs-8 d-flex align-items-start"
            key={`${index}_${key}`}
          >
            <span className="text-capitalize">
              • &nbsp;
              {typeof value === "object"
                ? `${key.replace(/_/g, " ")} ( ${explodeArray(value)} )`
                : key.replace(/_/g, " ")}
            </span>
          </div>
        ) : null
      )}

      {entries.length > 4 && (
        <div
          className="text-primary mt-2 fw-bold"
          style={{ cursor: "pointer", fontSize: "0.85rem" }}
          onClick={() => {
            if (actionBtn) {
              dispatch(setShowPaymentPlans(true));

            } else {
              setShowAll((prev) => !prev)
            }
          }
          }
        >
          {showAll ? t('payment.view_less') : t('payment.view_more')}
        </div>
      )}
    </div>
  );
}

export default FeaturesList;
